import { ca } from '@cian/analytics';
import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { getOfferType, isNewbuilding, isOldbuilding, isSuburban } from '../offer_type';

export type TMortgageBannerVerticalName = 'КаОБ_Первичка' | 'КаОБ_Вторичка' | 'КаОБ_Загородка' | 'КаЖК';

export type TMortgageBannerCianTerm = 'newbuilding' | 'flatsale' | 'suburban';

const BANNER_NAME = 'Циан.Ипотека';

/** UTM `cian_term` для ссылки «Циан.Ипотека» под ценой (ловушка под блоком цены). */
export function getMortgageBannerCianTerm(verticalName: TMortgageBannerVerticalName): TMortgageBannerCianTerm {
  switch (verticalName) {
    case 'КаОБ_Загородка':
      return 'suburban';
    case 'КаОБ_Вторичка':
      return 'flatsale';
    case 'КаОБ_Первичка':
    case 'КаЖК':
      return 'newbuilding';
  }
}

/** Ссылка на /ipoteka-main с разметкой ловушки под ценой. */
export function buildMortgageBannerUnderPriceIpotekaUrl(verticalName: TMortgageBannerVerticalName): string {
  const params = new URLSearchParams({
    cian_source: 'cian',
    cian_medium: 'trap',
    cian_campaign: 'mortgage_banner',
    cian_content: 'under_price_block',
    cian_term: getMortgageBannerCianTerm(verticalName),
  });

  return `/ipoteka-main/?${params.toString()}`;
}

function getMortgageBannerPageExtra(verticalName: TMortgageBannerVerticalName) {
  return {
    trap_type: 'under_price_block' as const,
    bannerName: BANNER_NAME,
    trapid: BANNER_NAME,
    vertical_name: verticalName,
  };
}

export function getMortgageBannerVerticalName(offer: IOfferSchema): TMortgageBannerVerticalName {
  const offerType = getOfferType(offer);

  if (isSuburban(offerType)) {
    return 'КаОБ_Загородка';
  }

  if (isNewbuilding(offerType)) {
    return offer.category === 'newBuildingFlatSale' ? 'КаОБ_Первичка' : 'КаЖК';
  }

  if (isOldbuilding(offerType)) {
    return 'КаОБ_Вторичка';
  }

  return 'КаОБ_Вторичка';
}

export function trackMortgageUnderPriceCianBannerShow(verticalName: TMortgageBannerVerticalName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'show_sopr',
    label: 'mortgage_banner',
    useLastProducts: true,
    page: {
      extra: getMortgageBannerPageExtra(verticalName),
    },
  });
}

export function trackMortgageUnderPriceCianBannerClick(verticalName: TMortgageBannerVerticalName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'trap',
    action: 'click_sopr',
    label: 'mortgage_banner',
    useLastProducts: true,
    page: {
      extra: getMortgageBannerPageExtra(verticalName),
    },
  });
}
